
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/Utility/Breadcrumb.vue";
import QaAnswerContent from "@/components/QA/QaAnswerContent.vue";
import { QaAnswerBlock } from "@/models/QaAnswer";

@Component({
  components: { Breadcrumb, QaAnswerContent },
})
export default class AcademyQA extends Vue {
  questions: { question: string; answer: QaAnswerBlock[] }[] = [
    {
      question: "我沒有相關經驗可以報名參加嗎？",
      answer: ["當然沒問題！非常歡迎零基礎的人報名師虎學院的課程。"],
    },
    {
      question: "上課的時間有幾種選擇？",
      answer: ["師虎學院培訓課程將定期開課，請參照網頁中公告之課程資訊。"],
    },
    {
      question: "我要怎麼報名課程？報名要準備什麼資料？",
      answer: [
        "線上受理登記報名，於確定開班後由專人通知您前往學院繳款。",
        "請準備以下資料：",
        {
          list: "ol",
          items: [
            "身分證（驗證身分用）",
            "兩吋大頭貼一張",
            "本人存摺封面影本，若台新帳戶會扣除手續費$30元（必攜帶存摺）",
          ],
        },
      ],
    },
    {
      question: "每班上課的人數有幾人？",
      answer: ["5人開班，一班不超過30人。"],
    },
    // 暫不顯示：
    // {
    //   question: "退費相關規定？",
    //   answer: ["依照短期補習班設立及管理準則標準。"],
    // },
  ];
}
